"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerExercise = exports.ExerciseWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const ContainerExercise = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-family: Phenomena;
    @media (max-width: 1200px) {
      padding: 0;
    }
    @media (max-width: 390px) {
        padding: 0;
        margin-top: 0px;
    }
    @media (max-width: 400px) {
        padding: 0;
        margin-top: -70px;
    }
    @media (max-width: 540px) {
        padding: 0;
        margin-top: -70px;
    }
    @media (max-height: 500px) {
      padding: 0;
      margin-top: 55px;
    }
`;
exports.ContainerExercise = ContainerExercise;
const ExerciseWrapper = styled_components_1.default.div `
    width: 100%;
    max-width: 100%;
    margin-left: 90px;
    margin-right: 90px;
    padding: 20px 35px;
    border-radius: 50px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border: 3px solid #fff;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 20px;
    margin-bottom: 12px;
    justify-content: space-between;
    margin-top: ${(props) => props.wihMargin ? "58px" : 0};
    position: relative;
    overflow: hidden;
    @media (max-height: 650px) {
        height: 90%;
        margin-top: -145px;
        border: 0;
        box-shadow: none;
        width: calc(90vw - 10px);
        margin-left: 5px;
        margin-right: 5px;
        padding: 0px;
        gap: 10px;
    }
    @media (max-width:950px ) {
        border: 0;
        box-shadow: unset;
        margin: 0;
        position: unset;
    }
    @media (max-width:700px ) {
        border: 0;
        box-shadow: unset;
        margin: 0;
        position: unset;
    }
    @media (max-width: 400px) {
        border: 0;
        box-shadow: none;
        width: calc(100vw - 10px);
        margin-left: 5px;
        margin-right: 5px;
        padding: 15px 35px;
        gap: 10px;
    }
    @media (max-width: 540px) {
        border: 0;
        box-shadow: none;
        width: calc(100vw - 10px);
        margin-left: 5px;
        margin-right: 5px;
        padding: 15px 35px;
        gap: 10px;
    }
`;
exports.ExerciseWrapper = ExerciseWrapper;
